import React, { useState } from "react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import * as gc from "@/growth/api";

export default function WorkspaceGate({ onReady, user }) {
  const [form, setForm] = useState({ display_name: user?.name || "", website_url: "", industry: "", country: "US" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!form.display_name) { toast.error("Business name required"); return; }
    setBusy(true);
    try {
      const r = await gc.ensureWorkspace({
        display_name: form.display_name,
        website_url: form.website_url || null,
        industry: form.industry || null,
        country: form.country,
        languages: ["en"],
      });
      onReady(r.workspace_id, form.website_url);
    } catch { toast.error("Could not create workspace"); }
    finally { setBusy(false); }
  };
  return (
    <div className="max-w-xl mx-auto py-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-bold uppercase tracking-widest">AI Growth Center</div>
        <h1 className="text-4xl font-black text-slate-900 mt-4">Set up your workspace</h1>
        <p className="text-slate-600 mt-2">One place where your website, SEO, AI visibility, and creative all connect.</p>
      </div>
      <Card className="p-6 border border-slate-200 rounded-2xl">
        <div className="space-y-3">
          <div>
            <Label>Business name</Label>
            <Input value={form.display_name} onChange={(e) => set("display_name", e.target.value)} placeholder="e.g. Cedar Grove Dental" data-testid="gc-onboard-name" />
          </div>
          <div>
            <Label>Website URL</Label>
            <Input value={form.website_url} onChange={(e) => set("website_url", e.target.value)} placeholder="https://your.site" data-testid="gc-onboard-url" />
          </div>
          <div>
            <Label>Industry (optional)</Label>
            <Input value={form.industry} onChange={(e) => set("industry", e.target.value)} placeholder="Dental practice, plumber, restaurant…" data-testid="gc-onboard-industry" />
          </div>
          <div>
            <Label>Country</Label>
            <select value={form.country} onChange={(e) => set("country", e.target.value)} className="mt-1 w-full h-10 rounded-md border border-slate-300 px-3 text-sm">
              <option value="US">United States</option>
              <option value="IN">India</option>
              <option value="OTHER">Other</option>
            </select>
          </div>
        </div>
        <Button onClick={submit} disabled={busy} className="mt-5 w-full bg-slate-900 hover:bg-slate-800 rounded-full" data-testid="gc-onboard-submit">
          {busy ? "Creating…" : "Create workspace"}
        </Button>
      </Card>
    </div>
  );
}
